import { useGetAudienceDesignatorOptions } from '@/api/hooks/data-mappings/useGetAudienceDesignatorOptions';
import DesignatorSelector from './DesignatorSelector';

export default function PaymentRailDesignator({
  formValues,
  isUpdating,
  onPaymentRailDesignatorChange,
  removePaymentRailDesignator,
  addPaymentRailDesignator,
}) {
  const { audienceDesignatorOptions } = useGetAudienceDesignatorOptions();

  return (
    <DesignatorSelector
      values={formValues?.payment_rails_designators || []}
      options={audienceDesignatorOptions}
      onChange={onPaymentRailDesignatorChange}
      onRemove={removePaymentRailDesignator}
      onAdd={addPaymentRailDesignator}
      disabled={!isUpdating('data-mapping')}
      label='Payment Rail Designator'
      tooltip='Create a composite key for payment rail routing by selecting multiple columns from the available data columns'
      previewTooltip="This is how the payment rail designator will be formatted. Each selected column's value will be combined with hyphens to create a unique identifier."
    />
  );
}
